import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import DelayedFallback from "./delayed-fallback";
import "../../styles/product/loading.scss";

export default function ProductLayout() {
  return (
    <main className="product">
      <ScrollRestoration />
      <Suspense
        fallback={
          <DelayedFallback delay={0}>
            <div className="loading_indicator">
              <img src="/images/logo/logo_black.svg" alt="Claimable" />
              Loading...
            </div>
          </DelayedFallback>
        }
      >
        <Outlet />
      </Suspense>
    </main>
  );
}
